import { StyleSheet } from 'react-native'

import { DS } from '../../design-system'

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F6F2E9',
    paddingHorizontal: 24
  },
  cardContainer: {
    padding: 16,
    marginBottom: 4,
    borderRadius: 12
  },
  userNameView: {
    justifyContent: 'space-between',
    height: 20,
    flexDirection: 'row'
  },
  emojiListContainer: {
    overflow: 'visible',
    flexDirection: 'row',
    width: '100%',
    marginLeft: 2,
    marginTop: 4,
    gap: 12
  },
  emojiIcon: {
    width: 24,
    height: 24
  },
  reactedEmojiContainer: {
    backgroundColor: DS.palette['Global/White'],
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 4
  },
  handRankings: {
    paddingVertical: 10,
    paddingHorizontal: 16,
    gap: 8,
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 30,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey'],
    width: '80%',
    alignSelf: 'center',
    position: 'absolute',
    bottom: 25,
    zIndex: 2,
    overflow: 'hidden'
  },
  headerContainer: {
    height: 64
  }
})
